import type { Role } from '@/types/user'
import { CLIENT_UPLOAD_STAGES, STAGE_COUNT, SUPPLIER_UPLOAD_STAGES } from './stages'

/** A valid stage is an integer 1..10. */
export function isValidStage(stage: number): boolean {
  return Number.isInteger(stage) && stage >= 1 && stage <= STAGE_COUNT
}

/**
 * Whether `role` may upload files to `stage` (spec §5.2.2 / §6.2.2).
 * Admin → all stages; Supplier → {1,6,7,8}; Client → {2,3,4,5,9,10}.
 */
export function canUploadStage(role: Role, stage: number): boolean {
  if (!isValidStage(stage)) {
    return false
  }
  if (role === 'admin') {
    return true
  }
  if (role === 'supplier') {
    return SUPPLIER_UPLOAD_STAGES.includes(stage)
  }
  return CLIENT_UPLOAD_STAGES.includes(stage)
}

/** Only Admin may toggle a stage's completion status Green/Red (spec §4.3.2). */
export function canEditStageStatus(role: Role): boolean {
  return role === 'admin'
}

/** Only Admin may create/edit/delete projects and manage users (spec §4). */
export function canManageProjects(role: Role): boolean {
  return role === 'admin'
}
